// src/pages/LandingPage.js
import React from 'react';
import { Link, Navigate } from 'react-router-dom';

const LandingPage = () => {

  if (localStorage.getItem('access_token')) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div
      className="min-h-screen flex flex-col bg-slate-900 text-white relative overflow-hidden"
      style={{
        backgroundImage: `
          linear-gradient(to right, rgba(255, 255, 255, 0.05) 1px, transparent 1px),
          linear-gradient(to bottom, rgba(255, 255, 255, 0.05) 1px, transparent 1px)
        `,
        backgroundSize: '40px 40px'
      }}
    >
      {/* Decorative Squash Court Elements */}
      <div className="absolute top-0 left-0 w-full h-1 bg-red-500/20" /> {/* Out of court line */}
      <div className="absolute bottom-1/4 left-0 w-full h-1 bg-red-500/20" /> {/* Service line / Tin */}
      <div className="absolute bottom-0 left-1/2 w-1 h-1/4 bg-red-500/20" /> {/* Half court line */}

      {/* Hero Section */}
      <section className="flex-grow flex flex-col items-center justify-center text-center px-6 py-20 relative z-10">
        <div className="max-w-4xl mx-auto space-y-8">
          <h1 className="text-6xl sm:text-7xl md:text-8xl font-black italic uppercase text-white leading-none tracking-tighter">
            Elevate Your <span className="text-red-500">Game</span>
          </h1>
          <p className="text-xl sm:text-2xl text-slate-400 max-w-2xl mx-auto font-medium">
            Train with purpose. Track your progress. Reach your full potential.
          </p>

          <div className="flex flex-col sm:flex-row gap-6 justify-center pt-8">
            <Link
              to="/login"
              className="px-10 py-4 rounded-none border-2 border-slate-700 bg-slate-800/80 text-white font-bold uppercase tracking-wider hover:bg-slate-700 hover:border-slate-500 transition-all duration-200"
            >
              Log In
            </Link>
            <Link
              to="/register"
              className="px-10 py-4 rounded-none bg-red-600 text-white font-black italic uppercase tracking-widest hover:bg-red-500 shadow-[0_0_20px_rgba(220,38,38,0.4)] transition-all duration-200 transform hover:-translate-y-1"
            >
              Get Started
            </Link>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="px-6 pb-24 relative z-10">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-8">
          {/* Guided Routines */}
          <div className="bg-slate-800/80 backdrop-blur-sm border-l-4 border-red-500 p-8 transform transition duration-300 hover:scale-105 hover:bg-slate-800">
            <h3 className="text-2xl font-black italic uppercase text-white mb-4 tracking-wide">Guided Routines</h3>
            <p className="text-slate-400 text-lg">
              Follow expert-designed drills with looping video demonstrations and built-in timers. Perfect your technique.
            </p>
          </div>

          {/* Streak Building */}
          <div className="bg-slate-800/80 backdrop-blur-sm border-l-4 border-red-500 p-8 transform transition duration-300 hover:scale-105 hover:bg-slate-800">
            <h3 className="text-2xl font-black italic uppercase text-white mb-4 tracking-wide">Streak Building</h3>
            <p className="text-slate-400 text-lg">
              Consistency is key. Build and maintain your training streaks to forge unbreakable habits on court.
            </p>
          </div>

          {/* Leaderboard Competition */}
          <div className="bg-slate-800/80 backdrop-blur-sm border-l-4 border-red-500 p-8 transform transition duration-300 hover:scale-105 hover:bg-slate-800">
            <h3 className="text-2xl font-black italic uppercase text-white mb-4 tracking-wide">Leaderboard Competition</h3>
            <p className="text-slate-400 text-lg">
              Take on academy challenges. Rise through the ranks and prove yourself on the leaderboard.
            </p>
          </div>

          {/* Fitness */}
          <div className="bg-slate-800/80 backdrop-blur-sm border-l-4 border-orange-500 p-8 transform transition duration-300 hover:scale-105 hover:bg-slate-800 flex flex-col justify-between">
            <div>
              <h3 className="text-2xl font-black italic uppercase text-white mb-4 tracking-wide">Fitness</h3>
              <p className="text-slate-400 text-lg mb-6">
                Track your runs and physical conditioning to ensure you have the stamina for five games.
              </p>
            </div>
            <Link
              to="/running-dashboard"
              className="mt-auto px-6 py-3 bg-orange-600 text-white font-bold uppercase tracking-wide text-center hover:bg-orange-500 transition-colors"
            >
              Log a Run
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="border-t border-slate-800 py-8 text-center text-slate-500 font-bold uppercase tracking-widest text-sm relative z-10">
        © {new Date().getFullYear()} SoloSync
      </footer>
    </div>
  );
};

export default LandingPage;
